export default __webpack_public_path__ + "static/media/gear.b409d1ff.svg";